import { presets, pt } from '../copy';

type PresetsProps = {
  onPick: (p: { id: string; label: string; location: string; years: number[] }) => void;
};

export default function Presets({ onPick }: PresetsProps) {
  return (
    <div className="space-y-3 rounded-3xl border border-white/10 bg-white/5 p-4 backdrop-blur-xl">
      <h2 className="text-sm font-medium text-white/80">{pt.presetsTitle}</h2>
      <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
        {presets.map((preset) => (
          <button
            key={preset.id}
            className="shrink-0 rounded-full border border-white/10 bg-black/25 px-4 py-2 text-left text-sm text-white/90 transition hover:border-white/20 hover:bg-white/10"
            type="button"
            onClick={() =>
              onPick({
                id: preset.id,
                label: preset.label,
                location: preset.location,
                years: [...preset.years],
              })
            }
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
}
